import { StackScreenProps } from "@react-navigation/stack";
import { Button, FlatActionList, Page } from "@towersystems/roam-common-native";
import { useGenericFilterListScreenProvider } from "./hooks";
import React from "react";
import { View } from "react-native-ui-lib";
import { FilterOptionType } from "./types";
import { Feather } from "@expo/vector-icons";
import colors from "react-native-ui-lib/src/style/colors";
import { useTranslation } from "../../utilities/i18n";

export type GenericFilterListScreenProps = StackScreenProps<
  any,
  "GenericFilterListScreen"
>;

export const GenericFilterListScreen = ({
  navigation,
}: GenericFilterListScreenProps) => {
  const { t } = useTranslation("product");
  const [selectedOptions, setSelectedOptions] = React.useState<string[]>([]);
  const { screenOptions } = useGenericFilterListScreenProvider();

  React.useEffect(() => {
    if (!screenOptions) {
      navigation.pop();
    } else {
      setSelectedOptions(screenOptions?.initialSelectedOptions || []);
    }
  }, []);

  React.useEffect(() => {
    navigation.setOptions({
      // stop users from accidently showing the title
      title: "",
      headerRight() {
        return (
          <Button
            label={t("common:clear_filters")}
            isAction
            disabled={selectedOptions.length == 0 || !screenOptions}
            onPress={handleOnClear}
            size="compact"
          ></Button>
        );
      },
    });
  }, [selectedOptions]);

  if (!screenOptions) {
    return <View />;
  }

  const handleOnClear = React.useCallback(() => {
    setSelectedOptions([]);
    screenOptions?.onClear?.();
    screenOptions?.onSelectOption?.([]);
  }, [selectedOptions]);

  const handleOnSelectOption = React.useCallback(
    (option: FilterOptionType) => {
      let newSelectedOptions = selectedOptions;

      if (selectedOptions.includes(option.id)) {
        newSelectedOptions = selectedOptions.filter((id) => id !== option.id);
      } else {
        newSelectedOptions = [...selectedOptions, option.id];
      }
      setSelectedOptions(newSelectedOptions);
      screenOptions?.onSelectOption?.(newSelectedOptions);
    },
    [selectedOptions]
  );

  const markup = (
    <FlatActionList
      items={screenOptions.options.map((option) => ({
        key: option.id,
        title: option.name,
        selected: selectedOptions.includes(option.id),
        onPress: () => handleOnSelectOption(option),
        componentRight: (icon) => {
          return selectedOptions.includes(option.id) ? (
            <Feather name="check" size={24} color={colors.primary} />
          ) : (
            icon
          );
        },
      }))}
    />
  );

  return <Page title={screenOptions?.title}>{markup}</Page>;
};
